<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Account Flags</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-1/2 md:pr-4">
                        <div class="account-body">
                            <form>
                                <div class="mb-3" v-for="(value, key) in flags">
                                    <label class="block text-gray-800 text-sm mb-2">{{ key }}</label>
                                    <input type="text" v-model="flags[key]" name="key"
                                           class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 md:pl-4">

                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "AccountFlagsView",
    props: {
        flags: Object
    },
    data() {
        return {
            account: null
        }
    },
    mounted() {
        this.setMetaTitle('View Account Flags | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    methods: {
        saveForm() {
            axios.post(route('accounts.update', this.$route.params.accountId), {
                flags: this.flags,
            }).then(response => {
                this.$bus.$emit('alert.success', 'Update Success')
            })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    }
}
</script>

<style lang="less">
.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
